
import usePrintDefinition from './usePrintDefinition';

import { getReport } from '../reducers/definition';

export default function useReport(reportId) {
    const printDefinition = usePrintDefinition();
    const report = getReport(printDefinition, reportId);
    return report;
}
